<template>
  <su-page title="会员中心">
    <el-row class="userCenter" slot="content">
      <el-row class="commonItem commonRightText">
        {{ form.name }}
        <!--(chinalanguage@foxmail.com)-->
      </el-row>
      <el-row class="commonItem">
        <div class="commonLeftText">会员组：</div>
        <div class="commonRightText">考生</div>
      </el-row>
      <el-row class="commonItem">
        <div class="commonLeftText">注册时间：</div>
        <div class="commonRightText">{{ form.register_at }}</div>
      </el-row>
      <el-row class="commonItem">
        <div class="commonLeftText">注册IP：</div>
        <div class="commonRightText">{{ form.ip }}</div>
      </el-row>
      <el-row class="commonItem">
        <div class="commonLeftText">上次登录IP：</div>
        <div class="commonRightText">{{ form.last_ip }}</div>
      </el-row>
      <el-row class="commonItem">
        <div class="commonLeftText">上次登录时间：</div>
        <div class="commonRightText">{{ form.last_at }}</div>
      </el-row>
    </el-row>
  </su-page>
</template>
<script>

import {record} from "@/api/api";

export default {
  name: "memberCenter",
  data() {
    return {
      form: {}
    }
  },
  mounted() {

  },
  created() {
    this.record()
  },
  methods: {
    record() {
      record().then(res => {
        if (res.status === 200) {
          this.form = res.data
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.userCenter {

}
</style>
